import React from 'react';
import { XCircleIcon, CheckCircleIcon } from 'lucide-react';
export function DecisionSection() {
  return <section className="w-full py-20 md:py-28 px-6 bg-beige" data-id="element-20">
      <div className="max-w-5xl mx-auto text-center" data-id="element-21">
        <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl text-dark mb-16 max-w-3xl mx-auto leading-tight" data-id="element-22">
          Puedes seguir intentando cambiar tu vida desde la superficie… o
          entender qué la está controlando y cambiarlo desde la raíz.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-23">
          {/* Seguir igual */}
          <div className="bg-white/40 p-10 rounded-2xl border border-dark/5 flex flex-col items-center text-center opacity-80" data-id="element-24">
            <h3 className="font-playfair text-2xl text-dark/60 font-medium mb-8" data-id="element-25">
              Seguir igual
            </h3>
            <ul className="space-y-4 text-dark/60 font-light text-left w-full max-w-xs mx-auto" data-id="element-26">
              <li className="flex items-start gap-3" data-id="element-27">
                <XCircleIcon className="w-5 h-5 mt-0.5 shrink-0" strokeWidth={1.5} data-id="element-28" />
                <span data-id="element-29">Repetir los mismos errores</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-30">
                <XCircleIcon className="w-5 h-5 mt-0.5 shrink-0" strokeWidth={1.5} data-id="element-31" />
                <span data-id="element-32">Sentir que no avanzas</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-33">
                <XCircleIcon className="w-5 h-5 mt-0.5 shrink-0" strokeWidth={1.5} data-id="element-34" />
                <span data-id="element-35">Cargar con culpas ajenas</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-36">
                <XCircleIcon className="w-5 h-5 mt-0.5 shrink-0" strokeWidth={1.5} data-id="element-37" />
                <span data-id="element-38">Vivir en ansiedad constante</span>
              </li>
            </ul>
          </div>

          {/* Romper el patrón */}
          <div className="bg-white p-10 rounded-2xl border border-terracotta/20 shadow-xl shadow-terracotta/5 flex flex-col items-center text-center relative overflow-hidden" data-id="element-39">
            <div className="absolute top-0 left-0 w-full h-1 bg-terracotta" data-id="element-40"></div>
            <h3 className="font-playfair text-2xl text-terracotta font-bold mb-8" data-id="element-41">
              Romper el patrón
            </h3>
            <ul className="space-y-4 text-dark font-medium text-left w-full max-w-xs mx-auto" data-id="element-42">
              <li className="flex items-start gap-3" data-id="element-43">
                <CheckCircleIcon className="w-5 h-5 text-terracotta mt-0.5 shrink-0" strokeWidth={2} data-id="element-44" />
                <span data-id="element-45">Entender tu historia familiar</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-46">
                <CheckCircleIcon className="w-5 h-5 text-terracotta mt-0.5 shrink-0" strokeWidth={2} data-id="element-47" />
                <span data-id="element-48">Liberar cargas emocionales</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-49">
                <CheckCircleIcon className="w-5 h-5 text-terracotta mt-0.5 shrink-0" strokeWidth={2} data-id="element-50" />
                <span data-id="element-51">Tomar decisiones propias</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-52">
                <CheckCircleIcon className="w-5 h-5 text-terracotta mt-0.5 shrink-0" strokeWidth={2} data-id="element-53" />
                <span data-id="element-54">Vivir con ligereza y paz</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}